import { render } from "./EditButton.vue?vue&type=template&id=7121e46e&scoped=true&ts=true"
import script from "./EditButton.vue?vue&type=script&lang=ts"
export * from "./EditButton.vue?vue&type=script&lang=ts"

import "./EditButton.vue?vue&type=style&index=0&id=7121e46e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7121e46e"]])

export default __exports__